import Icon from "@ant-design/icons";
import {CustomIconComponentProps} from "@ant-design/icons/es/components/Icon";
import React from "react";
import SVG from "react-inlinesvg";
import image from "assets/svg/icon-thunder.svg";

export const IconThunder = (props: Partial<CustomIconComponentProps> & {svgProps?: CustomIconComponentProps}) => (
    <Icon className="icon-thunder-bolt" component={() => <SVG src={image} {...props.svgProps} />} {...props} />
);
